import React, { Component } from 'react';
import L from 'leaflet';
import { Map, Marker, TileLayer } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
// import MarkerCluster from 'leaflet.markercluster';

class SharedRydeMap extends Component {

    render() {
        // const { subwayLinesFilter } = this.state;
        const redMarker = L.icon({
            iconUrl: 'https://npmcdn.com/leaflet@1.0.0-rc.3/dist/images/marker-icon.png',
            iconSize: [40, 40],
            iconAnchor: [20, 40],
        });

        const blackMarker = L.icon({
            iconUrl: './icons/busStop1.png',
            iconSize: [40, 40],
            iconAnchor: [20, 40],
        });
        const markers = [
            { position: [42.58349705, -71.80130303] },
            { position: [42.5812594701607, -71.7925823143239] },
            { position: [42.597304, -71.80602], popup: 'Burbank Hospital (Mechanic St.), Fitchburg' },
        ];
        return (
            <Map id="map" className="markercluster-map" center={[42.58349705, -71.80130303]} zoom={4} maxZoom={18}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                />
                <Marker position={[42.58349705, -71.80130303]} icon={redMarker}>
                </Marker>
                {/*<MarkerClusterGroup>
                        <Marker position={[42.58349705, -71.80130303]}  icon={redMarker}/>
                        <Marker position={[42.5812594701607, -71.7925823143239]}  icon={redMarker}/>
                        <Marker position={[42.597304, -71.80602]}  icon={redMarker}/>
                    </MarkerClusterGroup>*/}
            </Map>
        );
    }
}

export default SharedRydeMap;


// WEBPACK FOOTER //
// ./src/Componets/SharedRydeMap.js